
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bnKhH", function(module, exports) {

var $7kqqb = parcelRequire("7kqqb");


var $c3xd8 = parcelRequire("c3xd8");

const $121828a65173ad3f$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $c3xd8.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $7kqqb.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $121828a65173ad3f$export$e8b30f9c4a80230f;

});

parcelRegister("7kqqb", function(module, exports) {
const $5d54839cd273dd72$export$5ca004be156a127a = 'http://localhost:4224';
const $5d54839cd273dd72$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$1e9fed4c0197724c = 'http://localhost:8081';
const $5d54839cd273dd72$export$919a9569bce66f17 = '/api/v1/placements/';
const $5d54839cd273dd72$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $5d54839cd273dd72$export$67be2569ef5d7666 = 'http://localhost:9009';
const $5d54839cd273dd72$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $5d54839cd273dd72$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
module.exports["API_ORIGIN_TEST_SERVER"] = $5d54839cd273dd72$export$5ca004be156a127a;
module.exports["API_PATHNAME_TEST_SERVER"] = $5d54839cd273dd72$export$a5c5394c951a9848;
module.exports["API_ORIGIN_LOCAL"] = $5d54839cd273dd72$export$1e9fed4c0197724c;
module.exports["API_PATHNAME_LOCAL"] = $5d54839cd273dd72$export$919a9569bce66f17;
module.exports["API_PATHNAME_STG_PROD"] = $5d54839cd273dd72$export$d4fe3482c88e73a8;
module.exports["REMOTE_MODULE_URI_LOCAL"] = $5d54839cd273dd72$export$67be2569ef5d7666;
module.exports["REMOTE_MODULE_URI_STG"] = $5d54839cd273dd72$export$b49738b89db261cd;
module.exports["REMOTE_MODULE_URI_PROD"] = $5d54839cd273dd72$export$bbd96cd490b0df63;

});

parcelRegister("c3xd8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7kqqb = parcelRequire("7kqqb");

const $de5791e01a0486f7$export$b4ede87479bfcf09 = {
    currentEnv: 'local',
    envConfigs: {
        'test-server': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                pathname: (0, $7kqqb.API_ORIGIN_TEST_SERVER),
                searchParams: undefined
            }
        },
        test: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        local: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        dev: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_LOCAL),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: (0, $7kqqb.API_ORIGIN_LOCAL),
                pathname: (0, $7kqqb.API_PATHNAME_LOCAL),
                searchParams: undefined
            }
        },
        staging: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        'stg-fedm-east': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_STG),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        production: {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        },
        'prod-fedm-east': {
            remoteModule: {
                origin: (0, $7kqqb.REMOTE_MODULE_URI_PROD),
                pathname: undefined,
                searchParams: undefined
            },
            api: {
                origin: undefined,
                pathname: (0, $7kqqb.API_PATHNAME_STG_PROD),
                searchParams: undefined
            }
        }
    }
};
const $de5791e01a0486f7$export$fceca2c399b32565 = (0, $42omo.createContext)($de5791e01a0486f7$export$b4ede87479bfcf09);
const $de5791e01a0486f7$export$604607f913ef367c = $de5791e01a0486f7$export$fceca2c399b32565.Provider;
const $de5791e01a0486f7$export$877b97169cc75e8b = ()=>(0, $42omo.useContext)($de5791e01a0486f7$export$fceca2c399b32565);
module.exports["defaultEnvironmentValues"] = $de5791e01a0486f7$export$b4ede87479bfcf09;
module.exports["PostOfficeEnvironmentProvider"] = $de5791e01a0486f7$export$604607f913ef367c;
module.exports["usePostOfficeEnvironment"] = $de5791e01a0486f7$export$877b97169cc75e8b;

});

parcelRegister("5dPMD", function(module, exports) {
const $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $99c9a9fbdb7e3c13$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $99c9a9fbdb7e3c13$export$c4c39037cc4b06ab;

});

parcelRegister("PAiZW", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6cd46b79c049adec$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $6cd46b79c049adec$export$a228be81fcb77b42 = (0, $42omo.createContext)($6cd46b79c049adec$export$da5dc9062cba6715);
const $6cd46b79c049adec$export$3a10495c2cd2db0c = $6cd46b79c049adec$export$a228be81fcb77b42.Provider;
const $6cd46b79c049adec$export$b77983be89bb0a4e = $6cd46b79c049adec$export$3a10495c2cd2db0c;
const $6cd46b79c049adec$export$5bd9099e0ae94a43 = ()=>(0, $42omo.useContext)($6cd46b79c049adec$export$a228be81fcb77b42);
module.exports["defaultPostOfficeContextValue"] = $6cd46b79c049adec$export$da5dc9062cba6715;
module.exports["InternalPostOfficeContextProvider"] = $6cd46b79c049adec$export$3a10495c2cd2db0c;
module.exports["PostOfficeContextProvider"] = $6cd46b79c049adec$export$b77983be89bb0a4e;
module.exports["usePostOfficeContext"] = $6cd46b79c049adec$export$5bd9099e0ae94a43;

});

parcelRegister("6yHRM", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxT4C = parcelRequire("hxT4C");


var $4H1Ql = parcelRequire("4H1Ql");

const $d8346e8a2779e8cd$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $d8346e8a2779e8cd$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $d8346e8a2779e8cd$var$usePostOfficeRouteStore = ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $hxT4C.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $4H1Ql.useStableObject)(route);
};
const $d8346e8a2779e8cd$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $d8346e8a2779e8cd$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$d8346e8a2779e8cd$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $d8346e8a2779e8cd$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $42omo.createContext)($d8346e8a2779e8cd$var$initialState);
const $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $42omo.useRef)();
    if (!ref.current) ref.current = $d8346e8a2779e8cd$export$98c77e1bd702ed15(props);
    const route = $d8346e8a2779e8cd$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d8346e8a2779e8cd$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $d8346e8a2779e8cd$export$79301b66f7808cd8 = ()=>(0, $42omo.useContext)($d8346e8a2779e8cd$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $d8346e8a2779e8cd$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $d8346e8a2779e8cd$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $d8346e8a2779e8cd$export$79301b66f7808cd8;

});

parcelRegister("4H1Ql", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $6932c2b531d219ac$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $6932c2b531d219ac$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $42omo.useMemo)(()=>obj, $6932c2b531d219ac$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $6932c2b531d219ac$export$ed02d4adf2068b08;

});

parcelRegister("a8wvv", function(module, exports) {
const $f5ba185a6bfa7119$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined
};
const $f5ba185a6bfa7119$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $f5ba185a6bfa7119$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $f5ba185a6bfa7119$export$71ff7382870ef1b0;

});

parcelRegister("eXPKf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $h6POP = parcelRequire("h6POP");


var $42omo = parcelRequire("42omo");


var $fUB5z = parcelRequire("fUB5z");


var $a39tv = parcelRequire("a39tv");

const $3a8bbfb177ab8743$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $42omo.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $a39tv.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                name: (0, $h6POP.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $3a8bbfb177ab8743$export$b35129264a401b3c = /*#__PURE__*/ (0, $42omo.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $c6GJD.default).checkGate('post_office_update_ufov2_placements');
    /**
		 * If feature gate is not enabled, then we just return the children without the
		 * UFO segments attached.
		 */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $3a8bbfb177ab8743$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $3a8bbfb177ab8743$export$b35129264a401b3c;

});

parcelRegister("h6POP", function(module, exports) {

var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");

const $7e9b04f8bb48d01d$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: $fwDOR.default,
    UFOSegment: $hnvzE.default
};
module.exports["UFOv2"] = $7e9b04f8bb48d01d$export$c91b09caa8ecbab1;

});

parcelRegister("fUB5z", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $28f53716d0e10e9b$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $42omo.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $28f53716d0e10e9b$export$21b400a8c8ebc91a;

});

parcelRegister("a39tv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6d839c5f036ae335$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    const onMount = (0, $42omo.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $42omo.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
module.exports["usePerformanceTracking"] = $6d839c5f036ae335$export$317d52099614f316;

});

parcelRegister("MnX4h", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $jfBff = parcelRequire("jfBff");


var $1Ah4R = parcelRequire("1Ah4R");


var $3zCGc = parcelRequire("3zCGc");


var $kzyrP = parcelRequire("kzyrP");


var $goPQE = parcelRequire("goPQE");


var $kODQd = parcelRequire("kODQd");


var $coAgb = parcelRequire("coAgb");


var $eXPKf = parcelRequire("eXPKf");

/**
 * Feature gate name for GraphQL subscriptions in Post Office placements.
 * When disabled, subscriptions will not be enabled even if configured.
 */ const $e96f8aedef8f7ae2$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE = 'post-office_graphql_subscriptions_enabled';
const $e96f8aedef8f7ae2$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    // Check feature gate - subscriptions are only enabled if both:
    // 1. Feature gate is enabled
    // 2. subscription.enabled is true in config
    const isFeatureGateEnabled = (0, $c6GJD.default).checkGate($e96f8aedef8f7ae2$var$POST_OFFICE_GRAPHQL_SUBSCRIPTIONS_FEATURE_GATE);
    // Only pass subscription config if feature gate is enabled
    // This provides a kill switch even if config says enabled
    const effectiveSubscription = isFeatureGateEnabled ? subscription : undefined;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kzyrP.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $goPQE.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $coAgb.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1Ah4R.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kODQd.StableSubscriptionConfigProvider), {
                        subscription: effectiveSubscription,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3zCGc.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jfBff.RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $e96f8aedef8f7ae2$export$2b6596bcb1383a71;

});

parcelRegister("jfBff", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $5ba220ca4e76952d$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if ($5ba220ca4e76952d$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement'
        });
    }, [
        fireAnalyticsEvent,
        placementId
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["RenderTrackerProvider"] = $5ba220ca4e76952d$export$2d84fd9af6c9e378;

});

parcelRegister("7XIdu", function(module, exports) {

var $inPa6 = parcelRequire("inPa6");


var $42omo = parcelRequire("42omo");

const $ddf71c7c19f3c4df$export$85183a312807388d = 'postOffice';
const $ddf71c7c19f3c4df$export$33911828b25deac7 = 'engagementPlatform';
const $ddf71c7c19f3c4df$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $ddf71c7c19f3c4df$export$f7fadc54a04f9307 = {
    eventType: 'track',
    action: 'exposed',
    actionSubject: 'feature',
    source: 'engagement-platform',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ]
};
const $ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992 = {
    eventType: 'operational',
    action: 'stopped',
    actionSubject: 'message',
    source: 'epTargeting',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ],
    product: 'engagementPlatform'
};
const $ddf71c7c19f3c4df$export$f14470c9a12428fc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((eventPayload, attributes)=>{
        if (eventPayload.messageType === 'inapp') {
            const epMessageId = `engagement.inproduct.${eventPayload.messageId}`;
            createAnalyticsEvent({
                ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307,
                ...eventPayload,
                actionSubjectId: epMessageId,
                attributes: {
                    ...$ddf71c7c19f3c4df$export$f7fadc54a04f9307.attributes,
                    ...eventPayload.locale && {
                        locale: eventPayload.locale
                    },
                    ...attributes,
                    flagKey: epMessageId
                }
            }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
        } else createAnalyticsEvent({
            ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992,
            ...eventPayload,
            actionSubjectId: eventPayload.messageId,
            attributes: {
                ...$ddf71c7c19f3c4df$export$e0b2a6bfc6c6f992.attributes,
                ...eventPayload.locale && {
                    locale: eventPayload.locale
                },
                ...attributes
            }
        }).fire($ddf71c7c19f3c4df$export$33911828b25deac7);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
module.exports["useFirePostOfficeAnalyticsEvents"] = $ddf71c7c19f3c4df$export$57d19d18d6e255a5;
module.exports["useFireEngagementPlatformAnalyticsEvents"] = $ddf71c7c19f3c4df$export$f14470c9a12428fc;

});

parcelRegister("1Ah4R", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $ffCOo = parcelRequire("ffCOo");

const $6622e517a1cb034d$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "dd6f43a4834f98909ce4a860fc092b3de5c8bb52",
            b: "10950507",
            t: undefined
        }
    }
};
const $6622e517a1cb034d$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: $6622e517a1cb034d$var$postOfficeAnalyticsContextData,
        children: children
    });
};
module.exports["StableAnaltyicsProvider"] = $6622e517a1cb034d$export$5a66cdc9893b43e;

});

parcelRegister("3zCGc", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $PAiZW = parcelRequire("PAiZW");

var $c3xd8 = parcelRequire("c3xd8");


var $6zKHU = parcelRequire("6zKHU");


var $42omo = parcelRequire("42omo");

/**
 * Choreographer-specific debug logger instance
 */ const $a6536447802fda47$var$choreographerLogger = (0, $6zKHU.createInBrowserDebugLogger)('choreographer');
// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $a6536447802fda47$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        // CommonJS module
        $a6536447802fda47$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        // ESM module in browser
        $a6536447802fda47$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        // ESM module in Node.js
        $a6536447802fda47$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $a6536447802fda47$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ // @twood: NEVER CHANGE THIS DEFAULT VALUE
const $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a6536447802fda47$var$defaultContext = {
    choreographerEnabled: $a6536447802fda47$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a6536447802fda47$var$ChoreographerContext = /*#__PURE__*/ (0, $42omo.createContext)($a6536447802fda47$var$defaultContext);

const $a6536447802fda47$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $42omo.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $42omo.useState)(choreographer?.isDefaultEnabled ?? $a6536447802fda47$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $c3xd8.usePostOfficeEnvironment)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    (0, $42omo.useEffect)(()=>{
        if (choreographerEnabled) (parcelRequire("bh3sZ")).then((m)=>{
            // Autoresolve the ChoreographerRegistry class depending on whether the module is an ESM or CommonJS module
            const ChoreographerRegistryClass = $a6536447802fda47$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $a6536447802fda47$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $a6536447802fda47$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $a6536447802fda47$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $a6536447802fda47$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $42omo.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    // Log context changes outside of useMemo to avoid performance impact
    (0, $42omo.useEffect)(()=>{
        $a6536447802fda47$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        stableChoreographerContext,
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($a6536447802fda47$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext,
        children: children
    });
};
const $a6536447802fda47$export$cab5a8adbabcee23 = ()=>(0, $42omo.useContext)($a6536447802fda47$var$ChoreographerContext);
module.exports["StableChoreographerProvider"] = $a6536447802fda47$export$e68b2c75bfb5682a;
module.exports["useChoreographerContext"] = $a6536447802fda47$export$cab5a8adbabcee23;

});

parcelRegister("6zKHU", function(module, exports) {
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components
 *
 * Usage:
 * - Enable: window.postOfficeChoreographerDebug = true
 * - Disable: window.postOfficeChoreographerDebug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $101ad7de46cb7b68$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};
module.exports["createInBrowserDebugLogger"] = $101ad7de46cb7b68$export$806eda59584e395d;

});

parcelRegister("bh3sZ", function(module, exports) {

let $8353f8a5b3bf3a40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8353f8a5b3bf3a40$var$load("69dSh").then(()=>parcelRequire('fuev4'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("kzyrP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $PAiZW = parcelRequire("PAiZW");

var $4H1Ql = parcelRequire("4H1Ql");


var $a8wvv = parcelRequire("a8wvv");

const $d8708472710e950a$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $4H1Ql.useStableObject)({
        ...(0, $a8wvv.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $PAiZW.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
module.exports["StableContextProvider"] = $d8708472710e950a$export$d4982c0a28b18f63;

});

parcelRegister("goPQE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $8Bzrf = parcelRequire("8Bzrf");

const $2119b7887220da1c$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $4H1Ql.useStableObject)(placement);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $8Bzrf.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
module.exports["StablePlacementProvider"] = $2119b7887220da1c$export$e9fd288527498af6;

});

parcelRegister("8Bzrf", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $ffCOo = parcelRequire("ffCOo");


var $3Bn1T = parcelRequire("3Bn1T");


var $42omo = parcelRequire("42omo");

const $d26f31a8de6bf192$export$6394bf86db095a8 = /*#__PURE__*/ (0, $42omo.createContext)({
    placementId: undefined
});
const $d26f31a8de6bf192$export$6272e220478c7f1d = ({ value: value, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $3Bn1T.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, $l998X.jsx)($d26f31a8de6bf192$export$6394bf86db095a8.Provider, {
        value: memoizedValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.PostOfficeAnalyticsContext), {
            data: memoizedValue,
            children: children
        })
    });
};
const $d26f31a8de6bf192$export$4fc0446ee742ad80 = ()=>(0, $42omo.useContext)($d26f31a8de6bf192$export$6394bf86db095a8);
module.exports["PlacementProvider"] = $d26f31a8de6bf192$export$6272e220478c7f1d;
module.exports["usePlacementContext"] = $d26f31a8de6bf192$export$4fc0446ee742ad80;

});

parcelRegister("3Bn1T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6sni0 = parcelRequire("6sni0");

const $37d7f318e8260291$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $37d7f318e8260291$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $42omo.createContext)({
    placements: $37d7f318e8260291$var$initialPlacementState
});
const $37d7f318e8260291$export$70e19226ddeaf957 = ()=>(0, $42omo.useContext)($37d7f318e8260291$var$PostOfficeScreenContext);
const $37d7f318e8260291$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $42omo.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $37d7f318e8260291$export$5d27c0ee02be2a23 = ()=>(0, $42omo.useContext)($37d7f318e8260291$var$PostOfficeScreenUpdateContext);
const $37d7f318e8260291$export$ca77a8cbe94108fe = ({ children: children })=>{
    const [placements, setPlacements] = (0, $42omo.useState)($37d7f318e8260291$var$initialPlacementState);
    const placementMount = (0, $42omo.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $6sni0.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $6sni0.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $42omo.useCallback)(({ placementId: placementId })=>setPlacements((state)=>!state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: state.currentlyMounted.filter((e)=>e !== placementId)
            }), []);
    const postOfficeScreenUpdateContext = (0, $42omo.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $42omo.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d7f318e8260291$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($37d7f318e8260291$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $37d7f318e8260291$export$f51d04a086368016 = ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $37d7f318e8260291$export$5d27c0ee02be2a23();
    (0, $42omo.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};
module.exports["PostOfficeScreenContextProvider"] = $37d7f318e8260291$export$ca77a8cbe94108fe;
module.exports["usePostOfficeScreenPlacement"] = $37d7f318e8260291$export$f51d04a086368016;

});

parcelRegister("6sni0", function(module, exports) {
const $df02b7ceef3465b9$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
module.exports["uniqueArray"] = $df02b7ceef3465b9$export$bbd17ecb0679edd7;

});

parcelRegister("kODQd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $4fa55b3f6245b5e9$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $42omo.createContext)({
    subscription: undefined
});
const $4fa55b3f6245b5e9$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $42omo.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($4fa55b3f6245b5e9$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $4fa55b3f6245b5e9$export$1129f1fe63b2d7ab = ()=>{
    return (0, $42omo.useContext)($4fa55b3f6245b5e9$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $4fa55b3f6245b5e9$export$d870bd1cf2974c88;

});

parcelRegister("coAgb", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $kbN4i = parcelRequire("kbN4i");

const $ee97961d0a968e6e$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $kbN4i.useLocationHref)();
    const stableRoute = (0, $4H1Ql.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6yHRM.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
module.exports["StableRouteProvider"] = $ee97961d0a968e6e$export$ce13d00e696dfc96;

});

parcelRegister("kbN4i", function(module, exports) {
const $b036fb6e61b1c432$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $b036fb6e61b1c432$export$49fc3f3d8c7f99 = ()=>{
    return $b036fb6e61b1c432$var$isLocationAvailable() ? globalThis.location.href : undefined;
};
module.exports["useLocationHref"] = $b036fb6e61b1c432$export$49fc3f3d8c7f99;

});

parcelRegister("2HRxT", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $7TH2w = parcelRequire("7TH2w");


var $7XIdu = parcelRequire("7XIdu");


var $lAJUP = parcelRequire("lAJUP");

const $efad4e1316fb199e$export$f0c7a449e0cfaec7 = (Component)=>({ errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, fallbackRender: fallbackRender, onError: onError, ...data })=>{
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $7TH2w.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: error,
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $l998X.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId
            }, onError),
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...data
            })
        });
    };
module.exports["withErrorBoundary"] = $efad4e1316fb199e$export$f0c7a449e0cfaec7;

});

parcelRegister("hOVIX", function(module, exports) {
var $0a8f0e83dcf5160a$export$b9722560029694e7 = /*#__PURE__*/ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["RichRecipientError"] = "RichRecipientError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    return PostOfficeErrorCodes;
}({});
class $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 extends Error {
}
class $0a8f0e83dcf5160a$export$627bc00a5ef5f6ae extends Error {
}
class $0a8f0e83dcf5160a$export$d145ea5319863172 extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), this.code = code;
    }
}
function $0a8f0e83dcf5160a$export$4cb1ea6034a33155(error) {
    return typeof error === 'object' && !!error && 'status' in error && typeof error.status === 'number';
}
function $0a8f0e83dcf5160a$export$aed524b0009b5631(error) {
    return typeof error === 'object' && !!error && 'logLevel' in error && typeof error.logLevel === 'string';
}
class $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(args){
        /**
     * It is expected that this error message can be not deterministic.
     * This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
     * Showing the error cause helps them understand what was the problem with their payload.
     *
     * On Post Office (platform) side, we use "instanceof MessageTemplateError" check
     * to distinguish between message makers code errors and platform errors,
     * but we don't rely on the error message itself.
     */ const errMessage = args.cause instanceof Error ? args.cause.message : 'Error in message template code';
        super(errMessage, "MessageTemplateError", args.cause);
        this.function = void 0;
        this.messageTemplateId = void 0;
        this.triggerId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2833d4759f81601b extends $0a8f0e83dcf5160a$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = 'Invalid CSS property could not be processed by Juice';
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8d39b103586e9fd4 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f649da38897d27f7 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c2852c1c4d9aba3e extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4b7b4e09547e4bb3 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$360a094a97597d87 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$4d068b43eb55165b extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ac007ee150add337 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$19cb89dd679394cb extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$78651662ad470cc5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template not found', "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8a5041670cdd8db2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Journey not found', "JourneyNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1240ddc25cf964e6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Template action handler validation error', "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3c4884b7ae7fe517 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$913b8e68dc7ae8fe extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Placement not found', "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Message Renderer received empty response from validator', "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e5ccdf8bbfead7a2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$823733742d803ae6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Failed to send some events', "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1caa32527f23acd2 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(errorCause){
        super('Failed to send digest event to orchestration queue', "DigestEngineFailedSendError");
        this.errorCause = void 0;
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$a6f2aad8fa094b39 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? 'Unable to get user details for the given account ID', "UnableToGetUserDetailsError"), this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2f1e27130c2bf271 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError");
        this.payloadSize = void 0;
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$d0dc094613469f2b extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message);
        this.workspaceId = void 0;
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5603eab37ce562f5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(fileType){
        super('The attachment file is not supported', "UnsupportedAttachmentType");
        this.fileType = void 0;
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$e0e9aa0e9c6b37ff extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader");
        this.error = void 0;
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$3ad818f64601e141 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$25470bb6cba4fba0 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super('messageTemplateId not supported by placement', "UnsupportedMessageAtPlacementError");
        this.messageTemplateId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$ce14d445679448b6 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? 'unknown error', "HydrationFailureAtPlacementError");
        this.messageTemplateId = void 0;
        this.messageInstanceId = void 0;
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
}
class $0a8f0e83dcf5160a$export$c9a26a17db1045c8 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super('All messages failed at placement', "AllMessagesFailureHydrationAtPlacementError");
        this.placementId = void 0;
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$8ab4fb362168b928 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Unexpected invocation of validate() function for push delivery channel', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2afd69f57fe5285f extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(){
        super('Recipient expander not found for mapper', "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$7635d2b1a281d626 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError");
        this.errors = void 0;
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$9e1c6d00e675bc86 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor(message, recipient){
        super(message, "RichRecipientError");
        this.recipient = void 0;
        this.name = this.constructor.name;
        this.recipient = recipient;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$90bef7fa95eca3fa extends Error {
    constructor(status){
        super('Posting Mobile Notifications message failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$6d1a4929f6ff1a32 extends $0a8f0e83dcf5160a$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$c19fc5e8aa4e064d extends Error {
    constructor(){
        super('Ingestion source is required when custom profile is specified');
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$2d3a68dab93b8cc4 extends Error {
    constructor(){
        super('A renderRedacted function is required when redactionLevel is set to a non-null value');
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$175c1dbb0d7c238a extends Error {
    constructor(status){
        super('Enqueueing email failed'), this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
const $0a8f0e83dcf5160a$export$5c9840cf9181ada = 'post-office_enable_ca-ignore-upstream-errors';
const $0a8f0e83dcf5160a$export$a1f2446abf1cd73 = '1';
class $0a8f0e83dcf5160a$export$23fab744b3076342 extends Error {
    constructor(message, status){
        super(message), this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$194adecfa0265ea1 extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg);
        this.msg = void 0;
        this.messageInstanceId = void 0;
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
}
class $0a8f0e83dcf5160a$export$c504492f06c975b5 extends $0a8f0e83dcf5160a$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super('hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user', "HydrationDeliveryNoDataFoundError");
        this.ipmNumber = void 0;
        this.variantFromStatsig = void 0;
        this.contentfulLocale = void 0;
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$1c932b9d1680ee0b extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$5d5d1885c87ef4bc extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
class $0a8f0e83dcf5160a$export$f177e7d3a356e715 extends $0a8f0e83dcf5160a$export$5d5d1885c87ef4bc {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
}
module.exports["PostOfficeErrorCodes"] = $0a8f0e83dcf5160a$export$b9722560029694e7;
module.exports["PostOfficeError"] = $0a8f0e83dcf5160a$export$d145ea5319863172;
module.exports["InvalidMessageTemplateIdError"] = $0a8f0e83dcf5160a$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0a8f0e83dcf5160a$export$3dfc27a8d3942f4d;

});

parcelRegister("3Shv6", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f1cd061039c521e8$var$initialValue = {};
const $f1cd061039c521e8$export$b060d577040138d8 = (0, $42omo.createContext)($f1cd061039c521e8$var$initialValue);
const $f1cd061039c521e8$export$42de33f7652dc3de = $f1cd061039c521e8$export$b060d577040138d8.Provider;
const $f1cd061039c521e8$export$a5b6d14a2e25725a = ()=>(0, $42omo.useContext)($f1cd061039c521e8$export$b060d577040138d8);
module.exports["MessageContextProvider"] = $f1cd061039c521e8$export$42de33f7652dc3de;
module.exports["useMessageContext"] = $f1cd061039c521e8$export$a5b6d14a2e25725a;

});

parcelRegister("aEUWC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $03b25510c5956e6e$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $03b25510c5956e6e$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $42omo.createContext)($03b25510c5956e6e$var$defaultMessageAnalyticsContextValue);
const $03b25510c5956e6e$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $42omo.useRef)(false);
    const contextValue = (0, $42omo.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($03b25510c5956e6e$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $03b25510c5956e6e$export$bb426ba114b64992 = ()=>(0, $42omo.useContext)($03b25510c5956e6e$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $03b25510c5956e6e$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $03b25510c5956e6e$export$bb426ba114b64992;

});

parcelRegister("jVzfH", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $h6POP = parcelRequire("h6POP");


var $3Shv6 = parcelRequire("3Shv6");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $5RZ3F = parcelRequire("5RZ3F");


var $2amyA = parcelRequire("2amyA");


var $aEUWC = parcelRequire("aEUWC");

const $121622f1adade9d3$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $121622f1adade9d3$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense) })=>{
    const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
            name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $42omo.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            componentProps: componentProps,
            analyticsDetails: postOffice?.analyticsDetails
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps,
        postOffice
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5RZ3F.ChoreographerWrapper), {
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3Shv6.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hyvHs.RecommendationProvider), {
                    value: recommendationSession ?? $121622f1adade9d3$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                            children: [
                                messageSuccessComponent,
                                children
                            ]
                        })
                    })
                })
            })
        })
    });
};
module.exports["MessageRendererProvider"] = $121622f1adade9d3$export$5fe06fe68913d493;

});

parcelRegister("hyvHs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $bYRk6 = parcelRequire("bYRk6");


var $42omo = parcelRequire("42omo");

const $68ebcc2083a05cc4$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $42omo.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $68ebcc2083a05cc4$export$f60e87d7b5f59562 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($68ebcc2083a05cc4$export$ba2f44035effd9c1.Provider, {
        value: value,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: value,
            children: children
        })
    });
};
const $68ebcc2083a05cc4$export$3321c0b02f750bcc = ()=>(0, $42omo.useContext)($68ebcc2083a05cc4$export$ba2f44035effd9c1);
module.exports["RecommendationProvider"] = $68ebcc2083a05cc4$export$f60e87d7b5f59562;
module.exports["useRecommendationContext"] = $68ebcc2083a05cc4$export$3321c0b02f750bcc;

});

parcelRegister("5RZ3F", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $42omo = parcelRequire("42omo");


var $3zCGc = parcelRequire("3zCGc");

const $92519f251282f573$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $92519f251282f573$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($92519f251282f573$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $92519f251282f573$export$8db7ba034addcd65;

});

parcelRegister("2amyA", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $h6POP = parcelRequire("h6POP");

const $5a78db0628042bee$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
        name: (0, $h6POP.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOSegment, {
            name: `${(0, $h6POP.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $5a78db0628042bee$export$8e6fb7035018b3e4;

});

parcelRegister("gAOec", function(module, exports) {

var $7XIdu = parcelRequire("7XIdu");


var $5nZsM = parcelRequire("5nZsM");


var $42omo = parcelRequire("42omo");


var $6IMPA = parcelRequire("6IMPA");

class $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $42omo.useState)((0, $6IMPA.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $42omo.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $6IMPA.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $6IMPA.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $6IMPA.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($5nZsM)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $a8acaf5fcf658c6f$export$8c5224d3af2f3c8b;
module.exports["useData"] = $a8acaf5fcf658c6f$export$c1cf1cf4c5d51937;

});

parcelRegister("6IMPA", function(module, exports) {
const $7d79f12ff0021e5f$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $7d79f12ff0021e5f$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($7d79f12ff0021e5f$export$18a0019e5439b209(res));
};
const $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $7d79f12ff0021e5f$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $7d79f12ff0021e5f$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });
module.exports["assertResponseIsOk"] = $7d79f12ff0021e5f$export$b3732c8ff6f9c463;
module.exports["toLoading"] = $7d79f12ff0021e5f$export$f9a5bd0ffba29ffc;
module.exports["toError"] = $7d79f12ff0021e5f$export$cc3b967c039ed3e7;
module.exports["toData"] = $7d79f12ff0021e5f$export$24a6b176bdc41ce5;

});

parcelRegister("kO3gu", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1235947cddcdc3a4$export$afec669dc416ee7e = /*#__PURE__*/ (0, $42omo.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $1235947cddcdc3a4$export$e1e2cdb0425a9fa8 = ()=>(0, $42omo.useContext)($1235947cddcdc3a4$export$afec669dc416ee7e);
const $1235947cddcdc3a4$export$5f25a6ddf0324fa8 = ({ fetch: fetch, children: children })=>{
    const value = (0, $42omo.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($1235947cddcdc3a4$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};
module.exports["usePlacementFetchingContext"] = $1235947cddcdc3a4$export$e1e2cdb0425a9fa8;
module.exports["PlacementFetchingProvider"] = $1235947cddcdc3a4$export$5f25a6ddf0324fa8;

});


//# sourceMappingURL=post-office-placement-remote.e6b23ccd.js.map
